export default function applyFormTheme(formTheme, props) {
  const newProps = { ...props };
  if (!formTheme) {
    return newProps;
  }
  Object.keys(formTheme).forEach((prop) => {
    if (newProps[prop] === undefined) {
      newProps[prop] = formTheme[prop];
    }
  });
  return newProps;
}
